<div [id]="canvasId" class="map-container">
    <button id="btnRecenterPin" class="recenter-button" (click)="recenterMap()">
        <mat-icon class="map-icon" aria-hidden="true">pin_drop</mat-icon>
    </button>
</div>